var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-badge',{attrs:{"color":"yellow","dot":"","avatar":"","offset-x":_vm.offsetX,"offset-y":_vm.offsetY}})
}
var staticRenderFns = []

export { render, staticRenderFns }